import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DataContainer from 'Components/UI/DataContainer';
import { useMeetingContext } from 'Context/MeetingContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

import MeetingView from './View';
import useMissionControl from '../../useMissionControl';

const styles = theme => ({
  container: {}, // This style is only applied to the DataContainer
  root: {
    padding: theme.spacing(2),
  },
});

const MeetingContainer = ({
  className,
  classes,
}) => {
  const { householdResource } = useSimpleHousehold();
  const { meetingResource } = useMeetingContext();
  const { noMeetings } = useMissionControl();

  return (
    <div>
      {!noMeetings ? (
        <DataContainer
          className={classes.container}
          component={MeetingView}
          componentProps={{
            className: classNames(classes.root, className),
            householdResource,
            meetingResource,
          }}
          loading={!(meetingResource && householdResource)}
        />
      ) : null}
    </div>
  );
};

MeetingContainer.defaultProps = {
  className: '',
};

MeetingContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MeetingContainer);
